







































import Vue from "vue";
export default Vue.extend({
  data(): { [key: string]: any } {
    return {};
  },
  props: {
    column: {},
    row: {},
    hover: {
      type: Boolean
    }
  },
  inject: ["actionHandler"],
  computed: {
    isSampleIssued() {
      if ((this as any).row.status && (this as any).row.status === "ISSUED") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    handleTableClick(type: "request" | "edit") {
      this.actionHandler(type, this.row);
    }
  }
});
